import { CircularProgress, CircularProgressProps } from "@mui/material";

const AppCircularProgress = (prop: CircularProgressProps) => {
  return <CircularProgress {...prop} />;
};

export default AppCircularProgress;
